import useScopedTranslation from 'hooks/useScopedTranslation';
import { confirmModalI18n } from './i18n';

export default function ConfirmModal({
  Modal,
  show,
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmVariant = 'danger',
  onConfirm,
  onClose,
}) {
  const { t } = useScopedTranslation(confirmModalI18n);

  if (!Modal) return null;

  const resolvedTitle = title ?? t('confirmModal_title');
  const resolvedMessage = message ?? t('confirmModal_message');
  const resolvedConfirmLabel = confirmLabel ?? t('confirmModal_confirm');
  const resolvedCancelLabel = cancelLabel ?? t('confirmModal_cancel');

  return (
    <Modal
      title={resolvedTitle}
      show={show}
      onClose={onClose}
      primaryBtnTxt={null}
      secondaryBtnTxt={null}
      ctaAligment='right'
      width='560px'
    >
      <p className='mb-4'>{resolvedMessage}</p>

      <div className='d-flex justify-content-end gap-2'>
        <button className='btn btn-secondary' onClick={onClose}>
          {resolvedCancelLabel}
        </button>
        <button className={`btn btn-${confirmVariant}`} onClick={onConfirm}>
          {resolvedConfirmLabel}
        </button>
      </div>
    </Modal>
  );
}
